<!-- DESARROLLLO INICIADO  31/08/2020 wuilmer garcia -->
<template>
  <div>
    <!-- //////////////////////////////////////////////////
        //                PANTALLA PRINCIPAL                //
                                                                                                                                                                                                                                                                                                                                                                                                                                                                    /////////////////////////////////////////////////////    -->
    <v-row>
      <v-col cols="12" md="2" sm="6" class="">
        <AutocompleteComp v-model="filtro.id_pais" textLabel="País" :items="paisCurriculo" item-value="id_pais"
          item-text="nombre_pais" @change="filtroPais" autocomplete="off" />

      </v-col>

      <v-col cols="12" md="2" sm="6" class="">
        <AutocompleteComp textLabel="Currículo nacional" v-model="filtro.id_curriculo" :items="curriculoNac"
          item-value="id" item-text="curriculo" :disabled="inhabilitarCurriculo" @change="eventCurriculo" />

      </v-col>

      <v-col cols="12" md="2" sm="6" class="">
        <AutocompleteComp v-model="filtro.id_nivel" textLabel="Nivel" :items="listNivel" item-value="id"
          item-text="desc_nivel" @change="filtroNivel" :disabled="inhabilitarNivel" />

      </v-col>

      <v-col cols="12" md="3" sm="6">
        <AutocompleteComp textLabel="Grado" v-model="filtro.id_grado" :items="listGrado" item-value="id"
          item-text="desc_grado" @change="cargarCompCapDes" :disabled="inhabilitarGrado" />

      </v-col>

      <v-col cols="12" md="3" sm="6" class="">
        <AutocompleteComp textLabel="Área" v-model="filtro.id_area" :items="listArea" item-value="id"
          item-text="desc_area" @change="cargarCompCapDes" :disabled="inhabilitarArea" />

      </v-col>

      <v-col cols="12" class="d-flex justify-center">
        <TableButtonComp v-if="componenteEvento.agregar_submodulo" normalButton iconBut="fas fa-plus"
          textButton="Asociar Competencia" @click="addItem" />

      </v-col>
    </v-row>

    <!-- Item01  PRINCIPAL LISTAR COMPETENCIAS -->
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="d-flex justify-center text-subtitle-2">
            Leyenda
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="d-flex justify-center">
                <div class="leyenda-comptencia mx-2">
                </div>
                Competencia
                <div class="leyenda-capacidad mx-2">
                </div>
                Capacidades
                <div class="leyenda-desempeno mx-2">
                </div>
                Desempeños
              </v-col>
            </v-row>
          </v-card-text>

        </v-card>
      </v-col>

      <v-col cols="12" v-for="(item01, index01) in Datos" :key="index01" class="">
        <v-row>
          <v-col cols="12">
            <v-chip label>
              Nivel:{{ item01.desc_nivel }} | Grado:{{
                item01.desc_grado }} |
              Área: {{ item01.desc_area }}
            </v-chip>
          </v-col>
        </v-row>

        <!--  Item01  RENGLONES DE COMPETENCIAS -->
        <v-row v-for="(item02, index02) in item01.competencias" :key="index02">
          <v-col cols="12">
            <v-card outlined>
              <v-card-title class="d-flex text-subtitle-2">
                Competencias
              </v-card-title>
              <v-card-text>
                <v-row class="competencia white--text">
                  <v-col cols="3" class="py-0">
                    <v-checkbox dark :value="item02.id_competencia"
                      @change="eventCompetencia($event, index01, item02.id, index02)">
                    </v-checkbox>
                  </v-col>

                  <v-col cols="6" class="py-0 d-flex align-center">
                    <div>
                      <i class="fas fa-chevron-right fa-lg ico_competencia"></i>
                      {{ item02.id }} {{ item02.descripcion }}
                    </div>
                  </v-col>
                  <v-col cols="3" class="d-flex justify-end">
                    <v-btn class="btn_eliminar mr-2" fab x-small @click="deleteCompetencia(item02)"
                      :disabled="inhabilitarIcono">
                      <v-icon>fa-trash-alt</v-icon>
                    </v-btn>
                  </v-col>

                  <v-col cols="12" v-if="item02.capacidades">

                    <v-card outlined>
                      <v-card-title class="d-flex text-subtitle-2">
                        Capacidades
                        <v-spacer />
                        <v-btn class="btn_agregar" icon small @click="addCapacidad(item01, item02, index01, index02)"
                          :disabled="inhabilitarIcono">
                          <v-icon small>fa-plus</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-card-text>
                        <v-row class="capacidades white--text" v-for="(item03, index03) in item02.capacidades"
                          :key="index03">
                          <v-col cols="3" class="py-0">
                            <!--  event, indexPrincipal, id_competencia_area, indexComp, indexCap  -->
                            <v-checkbox dark :value="item03.id" @change="
                              eventCapacidad(
                                $event,
                                index01,
                                item03.id,
                                index02,
                                index03
                              )
                              " />
                          </v-col>

                          <v-col cols="6" class="d-flex align-center py-0">
                            <div>
                              <i class="fas fa-caret-right fa-lg ico_capacidad"></i>{{ item03.descripcion }}
                            </div>
                          </v-col>

                          <v-col cols="3" class="d-flex justify-end">
                            <v-btn class="btn_editar mr-2" fab x-small @click="
                              editCapacidad(item01, item02, item03, index01, index02)
                              " :disabled="inhabilitarIcono">
                              <v-icon>fa-pencil-alt</v-icon>
                            </v-btn>
                            <v-btn class="btn_eliminar mr-2" fab x-small @click="
                              deleteCapacidad(item03, index01, item02.id, index02)
                              " :disabled="inhabilitarIcono">
                              <v-icon>fa-trash-alt</v-icon>
                            </v-btn>
                          </v-col>

                          <!--
        /////////////////////////////////
        DESEMPEÑO O INIDICADORES
        /////////////////////////////////
                                                                                                                                                                                                                                                                                                                                                                                                                                                                -->

                          <v-col cols="12" v-if="item03.indicador">
                            <v-card>
                              <v-card-title class="d-flex text-subtitle-2">
                                Desempeños
                                <v-spacer />
                                <v-btn class="btn_agregar" fab x-small @click="
                                  addIndicador(
                                    item01,
                                    item02,
                                    item03,
                                    index01,
                                    item03.id,
                                    index02,
                                    index03
                                  )
                                  " :disabled="inhabilitarIcono">
                                  <v-icon x-small>fa-plus</v-icon>
                                </v-btn>
                              </v-card-title>
                              <v-card-text>
                                <v-row class="desempeno" v-for="(item04, index04) in item03.indicador" :key="index04">
                                  <v-col cols="8" class="">
                                    <div>
                                      <i class="fas fa-angle-double-right fa-lg ico_indicador"></i>{{
                                        item04.descripcion }}
                                    </div>
                                  </v-col>
                                  <v-col cols="4" class="d-flex justify-end align-center">
                                    <v-btn class="btn_editar mr-1" fab x-small @click="
                                      editIndicador(
                                        item01,
                                        item02,
                                        item03,
                                        item04,
                                        index01,
                                        item03.id,
                                        index02,
                                        index03
                                      )
                                      " :disabled="inhabilitarIcono">
                                      <v-icon>fa-pencil-alt</v-icon>
                                    </v-btn>
                                    <v-btn class="btn_eliminar ml-1" fab x-small @click="
                                      deleteIndicador(
                                        item04,
                                        index01,
                                        item03.id,
                                        index02,
                                        index03
                                      )
                                      " :disabled="inhabilitarIcono">
                                      <v-icon>fa-trash-alt</v-icon>
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-card-text>

                            </v-card>

                          </v-col>

                          <!-- Imten03 DETALLE DE INDICADORES O DESEMPEÑO -->


                        </v-row>
                      </v-card-text>
                    </v-card>


                  </v-col>

                </v-row>
              </v-card-text>
            </v-card>
          </v-col>





          <!--  CAPACIADADES INSERT -->


          <!-- Imten03 DETALLE DE CAPACIADADES -->



          <!-- FIN DE CAPACIDADES -->
        </v-row>
      </v-col>
    </v-row>

    <!-- fin de pantalla principal -->

    <!-- /////////////////////////////////////////////////////
             //     MODAL DE AGREGAR O EDITAR          //
          ////////////////////////////////////////////////////    -->
    <v-form ref="formDatos" lazy-validation>
      <v-dialog v-model="dialog" persistent scrollable max-width="800">
        <v-card>
          <v-card-title class="btn_otro">
            <span>{{ formTitle }}</span>
            <v-spacer></v-spacer>
            <span> País: {{ formDescPais }}</span>
            <v-spacer></v-spacer>
            <span>Currículo: {{ formDescCurriculo }}</span>
            <v-spacer></v-spacer>
            <v-btn fab dark x-small class="btn_style3" @click="dialog = false"><v-icon dark>fa-times</v-icon></v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-6">
            <v-row>
              <v-col cols="12" md="6" class="py-0">
                <v-autocomplete v-model="dataForm.id_nivel" label="Nivel" :items="listNivel" item-value="id"
                  item-text="desc_nivel" @change="filtroFormNivel" :rules="[rul.selectReq]" autocomplete="off">
                </v-autocomplete>

              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-autocomplete label="Área" v-model="dataForm.id_area" :items="listFArea" item-value="id"
                  item-text="desc_area" :rules="[rul.selectReq]" autocomplete="off">
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="6" class="py-0">
                <v-autocomplete label="Grado" v-model="dataForm.id_grado" multiple :items="listFGrado" item-value="id"
                  item-text="desc_grado" :rules="[rul.selectReq]" autocomplete="off">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" class="secondary text-center mb-2">
                <div class="font-weight-bold">DESCRIPCIÓN DE LA COMPETENCIA</div>
              </v-col>

              <v-col cols="12" class=" black--text" v-for="item in listCompetencia" :key="item.id">
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-checkbox v-model="dataForm.competencias" :value="item.id" class="my-0" color="#01579b"
                      :label="item.descripcion">
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-divider />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="btn_block_style2" dark v-if="this.evento == 'editar'"
              @click="saveItem(this.dataForm.id)">Guardar
              Cambios</v-btn>
            <v-btn class="btn_block_style2" dark v-if="this.evento == 'agregar'" @click="saveItem">Guardar</v-btn>
          </v-card-actions>
          <!-- <span v-if="test">
                          Datos del  Formulario: <code>{{dataForm}}</code>    
                      </span> -->
        </v-card>
      </v-dialog>
    </v-form>


    <v-dialog v-model="dialog_delete" width="550">
      <v-card>
        <v-card-title class="btn_ver">
          <label>Borrar registro</label>
          <v-spacer />
          <v-btn fab dark x-small class="btn_style3" @click="dialog_delete = false"><v-icon dark>fa-times</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="text-center black--text pt-8">
          <h3>
            ¿Está seguro de que desea borrar este registro?
          </h3>
          <div class="py-6">
            <div class="yellow py-2 px-3  rounded-pill mx-3" style="font-size:1rem">
              <span>{{ desc_delete }}</span>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_style3" dark @click="dialog_delete = false">No</v-btn>
          <v-btn class="btn_block_style2" dark @click="deleteItem">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog>
      <v-card>
        <v-card-title class="btn_ver">

          <label for="">Confirmar</label>
          <v-spacer />
          <v-btn fab dark x-small class="btn_style3" @click="dialog_confir = false"><v-icon dark>fa-times</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="text-center black--text">
          <h3>¿Desea registrar otra Competencia?</h3>
          <br />
        </v-card-text>

        <!-- modal dialogo de confirmación de COMPETENCIAS --->
        <v-dialog v-model="dialog_confir" width="550">
          <v-card>

            <v-card-title class="btn_ver">
              <v-row class="d-flex justify-space-between py-0">
                Confirmar
                <v-btn fab dark x-small class="btn_style3" @click="dialog_confir = false"><v-icon
                    dark>fa-times</v-icon></v-btn>
              </v-row>
            </v-card-title>

            <v-card-text class="text-center black--text">
              <h3>¿Desea registrar otra Competencia?</h3> <br>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn class="btn_style3" dark @click="confirEvent(false); dialog_confir = false">No</v-btn>

              <v-btn class="btn_block_style2" dark @click="confirEvent(true); dialog_confir = false">Si</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--------fin modal COMPETENCIAS-->
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_style3" dark @click="
            confirEvent(false);
          dialog_confir = false;
          ">No</v-btn>

          <v-btn class="btn_block_style2" dark @click="
            confirEvent(true);
          dialog_confir = false;
          ">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--------fin modal COMPETENCIAS-->

    <!-- //////////////////////////////////////////////////
        //////////////    CAPACIDADES             /////////////
        ///////////////////////////////////////////////////////    -->
    <!-- modal de agregar CAPACIDADES    -->
    <v-form ref="formDatos02" lazy-validation>
      <v-dialog v-model="dialog_capacidad" persistent scrollable max-width="800">
        <v-card>
          <v-card-title class="btn_otro">
            <label for="">{{ form02Title }} </label>
            <v-spacer />
            <v-btn fab dark x-small class="btn_style3" @click="dialog_capacidad = false"><v-icon
                dark>fa-times</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pt-2">
            <v-row class="py-3">
              <!--   <label class="font-weight-bold">SELECCIONE</label> -->
              <v-col cols="12" md="6">
                <v-text-field v-model="form02.desc_nivel" label="Nivel" :readonly="true"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="">
                <v-text-field v-model="form02.desc_grado" label="Grado" :readonly="true"></v-text-field>
              </v-col>

              <v-col cols="12" md="6" class="">
                <v-text-field v-model="form02.desc_area" label="Área" :readonly="true"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-textarea v-model="form02.desc_competencia" label="Competencia" :rules="[rul.required]" rows="1"
                  auto-grow :readonly="true"></v-textarea>
              </v-col>

              <v-col cols="12">
                <v-textarea v-model="form02.descripcion" label="Capacidad" :rules="[rul.required]" rows="1"
                  auto-grow></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn class="btn_block_style2" dark v-if="this.evento == 'editar'" @click="saveCapacidad(form02.id)">Guardar
              Cambios</v-btn>
            <v-btn class="btn_block_style2" dark v-if="this.evento == 'agregar'" @click="saveCapacidad">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!-- fin de modal agregar CAPACIDADES -->

    <!-- modal de borrar  CAPACIDADES    -->
    <v-dialog v-model="form02_delete" width="550">
      <v-card>
        <v-card-title class="btn_ver">
          <label>Borrar registro</label>
          <v-spacer />
          <v-btn fab dark x-small class="btn_style3" @click="form02_delete = false"><v-icon dark>fa-times</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="text-center black--text pt-8">
          <h3>
            ¿Está seguro de que desea borrar este registro?
          </h3>
          <div class="py-6">
            <div class="yellow py-2 px-3  rounded-pill mx-3" style="font-size:1rem">
              <span>{{ desc_delete }}</span>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_style3" dark @click="form02_delete = false">No</v-btn>
          <v-btn class="btn_block_style2" dark @click="deleteForm02">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- fin de modal de borrar CAPACIADES -->

    <!-- modal dialogo de confirmación de CAPACIADES --->
    <v-dialog v-model="dialog_confir_cap" width="550">
      <v-card>
        <v-card-title class="btn_ver">
          <label for="">Confirmar</label>
          <v-spacer />
          <v-btn fab dark x-small class="btn_style3" @click="
            confirEventCap(true);
          dialog_confir_cap = false;
          "><v-icon dark>fa-times</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="text-center black--text">
          <h3>¿Desea registrar otra capacidad?</h3>
          <br />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="btn_style3" dark @click="
            confirEventCap(false);
          dialog_confir_cap = false;
          ">No</v-btn>

          <v-btn class="btn_block_style2" dark @click="
            confirEventCap(true);
          dialog_confir_cap = false;
          ">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--------fin modal CAPACIDADES-->

    <!--------  END  CAPACIADES  -------->

    <!-- /////////////////////////////////////////////////////
        //////////////    DESEMPEÑO O INDICADORES    /////////////
        //////////////////////////////////////////////////////////    -->

    <!--      MODAL DE AGREGAR INIDICADORES   -->
    <v-form ref="formDatos03" lazy-validation>
      <v-dialog v-model="dialog_indicador" persistent scrollable max-width="850">
        <v-card>
          <v-card-title class="btn_otro">
            <label for=""> {{ form03Title }}</label>
            <v-spacer />
            <v-btn fab dark x-small class="btn_style3" @click="dialog_indicador = false"><v-icon
                dark>fa-times</v-icon></v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="pt-8">
            <v-row>
              <!--   <label class="font-weight-bold">SELECCIONE</label> -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field v-model="form03.desc_nivel" label="Nivel" :readonly="true"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-text-field v-model="form03.desc_grado" label="Grado" :readonly="true"></v-text-field>
              </v-col>

              <v-col cols="12" md="6" class="py-0">
                <v-text-field v-model="form03.desc_area" label="Área" :readonly="true"></v-text-field>
              </v-col>

              <v-col cols="12" md="12" class="py-0">
                <v-textarea v-model="form03.desc_competencia" label="Competencia" :rules="[rul.required]" rows="2"
                  auto-grow :readonly="true"></v-textarea>
              </v-col>

              <v-col cols="12" md="12" class="py-0">
                <v-textarea v-model="form03.desc_capacidades" label="Capacidad" :rules="[rul.required]" rows="2" auto-grow
                  :readonly="true"></v-textarea>
              </v-col>

              <v-col cols="12" md="12" class="py-0">
                <v-textarea v-model="form03.descripcion" label="Desempeño" :rules="[rul.required]" rows="2"
                  auto-grow></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn class="btn_block_style2" dark v-if="this.evento == 'editar'" @click="saveIndicador(form03.id)">Guardar
              Cambios</v-btn>
            <v-btn class="btn_block_style2" dark v-if="this.evento == 'agregar'" @click="saveIndicador">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!-- fin de modal agregar INDICADOR O DESEMPEÑO -->

    <!-- modal confirmación de INDICADOR O DESEMPEÑO --->
    <v-dialog v-model="dialog_confir_ind" width="550">
      <v-card>
        <v-card-title class="btn_ver">
          <v-row class="d-flex justify-space-between py-0">
            Confirmar
            <v-btn fab dark x-small class="btn_style3" @click="
              confirEventInd(false);
            dialog_confir_ind = false;
            "><v-icon dark>fa-times</v-icon></v-btn>
          </v-row>
        </v-card-title>

        <v-card-text class="text-center black--text">
          <h3>¿Desea registrar otro desempeño?</h3>
          <br />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="btn_style3" dark @click="
            confirEventInd(false);
          dialog_confir_ind = false;
          ">No</v-btn>
          <v-btn class="btn_block_style2" dark @click="
            confirEventInd(true);
          dialog_confir_ind = false;
          ">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--------fin modal  confirmación DESEMPEÑO O INDICADORES -->

    <!-- modal de borrar DESEMPEÑO O INDICADORES  -->
    <v-dialog v-model="form03_delete" width="550">
      <v-card>
        <v-card-title class="btn_ver">
          <label for="">Borrar registro</label>
          <v-spacer />
          <v-btn fab dark x-small class="btn_style3" @click="form03_delete = false"><v-icon dark>fa-times</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="text-center black--text pt-8">
          <h3>
            ¿Está seguro de que desea borrar este registro?
          </h3>
          <div class="py-6">
            <div class="yellow py-2 px-3  rounded-pill mx-3" style="font-size:1rem">
              <span>{{ desc_delete }}</span>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_style3" dark @click="form03_delete = false">No</v-btn>
          <v-btn class="btn_block_style2" dark @click="deleteForm03">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- fin de modal de borrarDESEMPEÑO O INDICADORES -->

    <!-------- END  DESEMPEÑO O INDICADORES   ----------->
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
// eslint-disable-next-line
import { join } from "path";
// import seleccionCompetenciaDesempeño from "../../../seleccionCompetenciaDesempeño.vue";
import AutocompleteComp from "@/components/ComponentsEst/AutocompleteComp.vue";
import TableButtonComp from "@/components/ComponentsEst/TableButtonComp.vue";

export default {
  // eslint-disable-next-line
  components: {

    AutocompleteComp,
    TableButtonComp,
  },
  name: "formAsignarCompetencia",

  props: ["estadoComp", "parametros"],

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 77, id_modulo: 4 }, //sud_modulo y modulo
    datoLogin: sessionStorage, // variables de sesion del usuario
    test: false,
    ////////////////////////////////////////////////////////

    search: "",
    Datos: [],
    filtro: {},
    pais: [],

    curriculoNac: [],
    paisCurriculo: [],
    listCurriculo: [],
    listCompetencia: [],

    listNivel: [],
    listGrado: [],
    listArea: [],

    listFGrado: [],
    listFArea: [],

    inhabilitarIcono: true,
    inhabilitarCurriculo: true,
    inhabilitarNivel: true,
    inhabilitarGrado: true,
    inhabilitarArea: true,

    // MODAL AGREGRAR-EDITAR COMPETENCIA
    evento: null,
    titulo: "competencias",
    dialog: false,
    formTitle: "",
    formDescPais: "",
    formDescCurriculo: "",
    dataForm: {},

    dialog_confir: false,

    // MODAL PARA CAPACIDAD
    dialog_capacidad: false,
    form02: {},
    form02Title: null,
    form02_delete: false,
    dialog_confir_cap: false,

    // MODAL PARA INDICADOR O DESEMPEÑO
    dialog_indicador: false,
    form03: {},
    form03Title: null,
    form03_delete: false,

    dialog_confir_ind: false,

    // MODAL BORRAR NOTA LITERAL
    dialog_delete: false,
    desc_delete: null,
    id_delete: null,
    ///////////////////////////////

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo requerido",
      inputReq: (value) => !!value || "Campo requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo Electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo Electrónico es incorrecto";
        }
      },
    },
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },

  watch: {
    // cada vez que la pregunta cambie desde el componente padre, esta función será ejecutada
    estadoComp: function (newValor, oldValor) {
      console.log(newValor + oldValor);

      if (this.estadoComp) {
        this.actualizarParamentro();
        this.loadMain();
      } else {
        //this.limpiarFormUsuario()
      }
    },
  },

  mounted() {
    this.loadMain();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //  ------- MOSTRAR TODOS LOS REGISTROS    --------
    async loadMain() {
      this.filtro.id_pais = null;
      this.filtro.id_curriculo = null;
      this.inhabilitarIcono = true;
      this.inhabilitarCurriculo = true;
      this.inhabilitarNivel = true;
      this.inhabilitarGrado = true;
      this.inhabilitarArea = true;

      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
      };

      try {
        let response01 = await axios.get("/manager/curriculo/ps/fil/", params);
        this.paisCurriculo = response01.data;
        //console.log(response01.data)
        this.listarCurriculo();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async listarCurriculo() {
      try {
        let params02 = { id: null, id_curriculo: null };
        let response02 = await axios.post(
          "manager/curriculo/cr/list/",
          params02
        );
        this.listCurriculo = response02.data;
        this.Datos = [];
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async limpiarForm() {
      this.dataForm = {
        id_usuario: this.datoLogin.id,
        id_us_ing: this.datoLogin.id,
        id_us_mod: this.datoLogin.id,
        competencias: [],
        id_pais: this.filtro.id_pais,
        id_curriculo: this.filtro.id_curriculo,
        id_nivel: "",
        id_grado: "",
        id_area: "",
      };

      this.listCompetencia = [];
      this.resetValidation();
    },

    // Validar resetear campos al guardar
    resetValidation() {
      this.$refs.formDatos.resetValidation();
    },

    //////////  Filtro de curriculo por pais  /////////
    async filtroPais() {
      try {
        this.inhabilitarNivel = false;
        this.inhabilitarCurriculo = false;
        this.inhabilitarGrado = true;
        this.inhabilitarArea = true;
        this.filtro.id_curriculo = null;
        this.filtro.id_nivel = null;
        this.filtro.id_grado = null;
        this.filtro.id_area = null;
        this.Datos = [];

        // console.log(`Filtro por país: ${this.filtro.id_pais}`)
        this.curriculoNac = this.listCurriculo.filter(
          (el) => el.id_pais == this.filtro.id_pais
        );

        let resp = await axios.get(
          `/manager/competenciasArea/nfilt/${this.filtro.id_pais}`
        );
        this.listNivel = resp.data;
        //console.log(resp.data)
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    // Listar Capacidades Competencias Desempeño
    async cargarCompCapDes() {
      this.Datos = [];

      try {
        let resp = await axios.post(
          `/manager/competenciasArea/call/`,
          this.filtro
        );
        this.Datos = resp.data;
        //console.log(resp.data)
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    ///////////////////////////////////////////////////
    //////////  Filtro de nivel   /////////
    async filtroNivel() {
      try {
        this.inhabilitarGrado = false;
        this.inhabilitarArea = false;

        this.filtro.id_grado = null;
        this.filtro.id_area = null;
        this.Datos = [];

        // lista los grados por el nivel
        let resp01 = await axios.get(
          `/manager/competenciasArea/gfilt/${this.filtro.id_nivel}`
        );
        this.listGrado = resp01.data;

        // lista los areas por el nivel
        let resp02 = await axios.get(
          `/manager/competenciasArea/afilt/${this.filtro.id_nivel}`
        );
        this.listArea = resp02.data;
        //console.log(resp02.data)

        this.cargarCompCapDes();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //////////  Filtro de nivel Formulario   /////////
    async filtroFormNivel() {
      try {
        this.inhabilitarGrado = false;
        this.inhabilitarArea = false;

        this.dataForm.id_grado = "";
        this.dataForm.id_area = "";
        this.Datos = [];

        // lista los grados por el nivel
        let resp01 = await axios.get(
          `/manager/competenciasArea/gfilt/${this.dataForm.id_nivel}`
        );
        this.listFGrado = resp01.data;

        // lista los areas por el nivel
        let resp02 = await axios.get(
          `/manager/competenciasArea/afilt/${this.dataForm.id_nivel}`
        );
        this.listFArea = resp02.data;
        //console.log(resp02.data)

        let resp03 = await axios.get(
          `/manager/competencia/${this.filtro.id_curriculo}`
        );
        this.listCompetencia = resp03.data;
        this.dataForm.competencias = [];
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //////////  Filtro de Competencias Sin Asignar  /////////
    async filtroFormArea() {
      try {
        if (this.dataForm.id_area) {
          // lista los compentencia por nivel, grado, area sin asignar
          let resp = await axios.post(
            `/manager/competenciasArea/compSinAsignar/`,
            this.dataForm
          );
          this.listCompetencia = resp.data;
          this.dataForm.competencias = [];
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    // Evento de Confirmacion de Modal de Capacidades Agregar otra Capacidad
    async confirEvent(event) {
      // Continuar Ingrsando true
      if (event) {
        this.dataForm.id_area = "";
        this.listCompetencia = [];
        this.dataForm.competencias = null;
        this.resetValidation();
      } else {
        this.dialog = false;
        this.dialog_confir = false;
        this.cargarCompCapDes();
      }
    },

    // listar los datos de COMPETENCIAS CREADAS
    async eventCurriculo() {
      try {
        let filtroCurriculo = this.curriculoNac.filter(
          (item) => item.id == this.filtro.id_curriculo
        );
        // innhabilitar icono el los datos a listar si el curriculo seleccionado esta desactivado = 0

        if (filtroCurriculo[0].status == 1) {
          this.inhabilitarIcono = false;
        } else {
          this.inhabilitarIcono = true;
        }

        this.cargarCompCapDes();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //----------- AREGAR REGISTROS  --------------
    async addItem() {
      this.limpiarForm();

      if (this.filtro.id_curriculo) {
        this.formTitle = "Asociar " + this.titulo;

        let pais = this.paisCurriculo.filter(
          (item) => item.id_pais == this.filtro.id_pais
        );
        let curriculo = this.curriculoNac.filter(
          (item) => item.id == this.filtro.id_curriculo
        );

        this.formDescPais = pais[0].nombre_pais;
        // curriculo cod_curriculo
        this.formDescCurriculo = curriculo[0].cod_curriculo;
        this.dialog = true;
        this.evento = "agregar";
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe Seleccionar un Curriculo Activo`,
          tiempo: null,
        });
      }
    },

    //--------------EDITAR REGISTRO--------------
    editItem(item) {
      this.limpiarForm();
      this.formTitle = "Editar " + this.titulo;

      this.dialog = true;
      this.evento = "editar";
      item.id_usuario = this.datoLogin.id;
      this.dataForm = Object.assign({}, item);
    },

    // Guardar registro
    async saveItem(id) {
      //console.log(this.dataForm);
      if (
        this.$refs.formDatos.validate() &&
        this.dataForm.competencias.length > 0
      ) {
        try {
          var res = "";

          if (this.evento == "agregar") {
            res = await axios.post("/manager/competenciasArea/", {
              datos: this.dataForm,
            });
            // levanta mensaje de confirmacion
            this.dialog_confir = true;
          }

          if (this.evento == "editar") {
            res = await axios.put(
              "/manager/competenciasArea/" + id,
              this.dataForm
            );
            this.dialog = false;
            this.evento = null;
          }

          this.setEnviarMens({
            tipo: `${res.data.messageT}`,
            mensaje: `${res.data.message}`,
            tiempo: null,
          });
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de Ingresar todo los campos requeridos`,
          tiempo: null,
        });
      }
    },

    //////////////////////////////////////////////////
    /////////          COMPETENCIA            ////////
    //////////////////////////////////////////////////
    async deleteCompetencia(items) {
      this.dialog_delete = true;
      this.id_delete = items.id;
      this.desc_delete = `${items.descripcion} - (${items.id})`;
    },

    //------------BORRAR Registro COMPETENCIA -------------
    async deleteItem() {
      this.dialog_delete = false;
      try {
        let resp = await axios.delete(
          "/manager/competenciasArea/" + this.id_delete
        );
        this.dialog = false;
        this.cargarCompCapDes();
        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: resp.data.message,
          tiempo: null,
        });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //listar las  CAPACIDADES a dar click en una Competencia
    async eventCompetencia(
      event,
      indexPrincipal,
      id_competencia_area,
      indexComp,
      recargar = false
    ) {
      // event: si esta chequeado o NO la competencia (true, false)
      // indexPrincipal:  posicion del elemento del index Principal
      // id_competencia_area:  campo unico de la tabla competencia
      // indexComp: posicion del elemento de la compentencia
      if (recargar) {
        this.Datos[indexPrincipal].competencias[indexComp].capacidades = [];
      }
      if (event) {
        try {
          // Listar las Capacidades por Competencias
          var resp = await axios.get(
            `/manager/capacidad/gall/${id_competencia_area}`
          );
          // this.listCompetencia   = resp.data;

          if (resp.data.length == 0) {
            this.Datos[indexPrincipal].competencias[indexComp].capacidades = [];
          } else {
            this.Datos[indexPrincipal].competencias[indexComp].capacidades =
              resp.data;
          }
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
        //check es false
      } else {
        this.Datos[indexPrincipal].competencias[indexComp].capacidades = null;
      }
    },

    //------    END COMPETENCIA            --------  //

    //////////////////////////////////////////////////
    /////////          CAPACIDADES            ////////
    //////////////////////////////////////////////////
    async limpiarForm02() {
      this.form02 = {
        id_usuario: this.datoLogin.id,
        id_us_ing: this.datoLogin.id,
        id_us_mod: this.datoLogin.id,
        id: null,
        id_competencia_area: "",
        desc_nivel: "",
        desc_grado: "",
        id_capacidad: "",
        descripcion: "",
        indexPrincipal: "",
        indexComp: "",
      };

      this.resetValidationCap();
    },

    //listar las INDICADORES O DESEMPEÑO  a dar click en una Capacidad
    async eventCapacidad(
      event,
      indexPrincipal,
      id_capacidad,
      indexComp,
      indexCap
    ) {
      // event si esta checkqueado o NO la capacidad

      if (event) {
        try {
          // Listar los Indicadores o Desempeños
          var resp = await axios.get(`/manager/indicador/gall/${id_capacidad}`);

          if (resp.data.length == 0) {
            this.Datos[indexPrincipal].competencias[indexComp].capacidades[
              indexCap
            ].indicador = [];
          } else {
            this.Datos[indexPrincipal].competencias[indexComp].capacidades[
              indexCap
            ].indicador = resp.data;
          }
          // this.setEnviarMens({tipo:"E", mensaje: `HOLA 01`, tiempo:null})
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
          this.Datos[indexPrincipal].competencias[indexComp].capacidades[
            indexCap
          ].indicador = [];
        }

        // Limpia los Indicadores Seleccionado
      } else {
        // this.setEnviarMens({tipo:"E", mensaje: `HOLA 03`, tiempo:null})
        this.Datos[indexPrincipal].competencias[indexComp].capacidades[
          indexCap
        ].indicador = null;
      }
    },

    async addCapacidad(competencia, capacidades, indexPrincipal, indexComp) {
      // console.log(`ITEMES COMPETENCIA: ${competencia}`)
      //  console.log(competencia)
      // console.log(`ITEMES CAPACIDADES: ${capacidades}`)
      // console.log(capacidades)
      this.limpiarForm02();

      this.dialog_capacidad = true;
      this.evento = "agregar";
      this.form02Title = "Agregar capacidad";
      this.form02.desc_nivel = competencia.desc_nivel;
      this.form02.desc_grado = competencia.desc_grado;
      this.form02.desc_area = competencia.desc_area;
      this.form02.id_capacidad = capacidades.id_capacidad;
      // ID_COMPETENCIA_AREA
      this.form02.id_competencia_area = capacidades.id;
      this.form02.indexPrincipal = indexPrincipal;
      this.form02.indexComp = indexComp;
      this.form02.desc_competencia = capacidades.descripcion;
    },

    async editCapacidad(
      itemsPrincipal,
      competencia,
      capacidad,
      indexPrincipal,
      indexComp
    ) {
      //console.log(capacidad)
      this.limpiarForm02();

      this.dialog_capacidad = true;
      this.evento = "editar";
      this.form02Title = "Editar capacidad";
      this.form02.desc_nivel = itemsPrincipal.desc_nivel;
      this.form02.desc_grado = itemsPrincipal.desc_grado;
      this.form02.desc_area = itemsPrincipal.desc_area;
      this.form02.desc_competencia = competencia.descripcion;
      // ID_COMPETENCIA_AREA
      this.form02.id = capacidad.id;
      this.form02.id_competencia_area = capacidad.id_competencia_area;
      this.form02.indexPrincipal = indexPrincipal;
      this.form02.indexComp = indexComp;

      this.form02.descripcion = capacidad.descripcion;
    },

    async deleteCapacidad(
      items,
      indexPrincipal,
      id_competencia_area,
      indexComp
    ) {
      this.form02_delete = true;
      this.id_delete = items.id;
      this.desc_delete = items.descripcion;
      this.form02.id_competencia_area = id_competencia_area;
      this.form02.indexPrincipal = indexPrincipal;
      this.form02.indexComp = indexComp;
    },

    // Guardar registro PARA CAPACIADES
    async saveCapacidad(id) {
      //console.log(this.form02);
      if (this.$refs.formDatos02.validate()) {
        try {
          var res = "";
          if (this.evento == "agregar") {
            res = await axios.post("/manager/capacidad/", {
              datos: this.form02,
            });
            this.dialog_confir_cap = true;
          }

          if (this.evento == "editar") {
            res = await axios.put("/manager/capacidad/" + id, this.form02);
            // this.evento  = null
          }

          this.dialog_capacidad = false;
          this.setEnviarMens({
            tipo: `${res.data.messageT}`,
            mensaje: `${res.data.message}`,
            tiempo: null,
          });
          // recarga todas las capacidades
          this.eventCompetencia(
            1,
            this.form02.indexPrincipal,
            this.form02.id_competencia_area,
            this.form02.indexComp,
            true
          );
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de Ingresar todo los campos requeridos`,
          tiempo: null,
        });
      }
    },

    //------------BORRAR Registro (Capacidades) -------------
    async deleteForm02() {
      this.form02_delete = false;

      try {
        let resp = await axios.delete("/manager/capacidad/" + this.id_delete);
        this.dialog = false;
        // recarga todas las capacidades
        this.eventCompetencia(
          1,
          this.form02.indexPrincipal,
          this.form02.id_competencia_area,
          this.form02.indexComp,
          true
        );
        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: resp.data.message,
          tiempo: null,
        });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    // Evento de Confirmacion de Modal de Capacidades Agregar otra Capacidad
    async confirEventCap(event) {
      // Continuar Ingrsando true
      // alert("confirEventCap")
      if (event) {
        this.form02.descripcion = "";
        this.dialog_capacidad = true;
        this.resetValidationCap();
      } else {
        this.dialog_capacidad = false;
      }
      // actualiza todas las capacidades capacidades

      //console.log("aqui eventCompetencia")
      this.eventCompetencia(
        1,
        this.form02.indexPrincipal,
        this.form02.id_competencia_area,
        this.form02.indexComp
      );
    },

    //  resetear Validcion de los campos capaciades
    resetValidationCap() {
      this.$refs.formDatos02.resetValidation();
    },
    //-----     END  CAPACIDADES          ----////////

    //////////////////////////////////////////////////
    /////////     INIDICADOR  O DESEMPEÑO     ////////
    //////////////////////////////////////////////////
    async limpiarForm03() {
      this.form03 = {
        id_usuario: this.datoLogin.id,
        id_us_ing: this.datoLogin.id,
        id_us_mod: this.datoLogin.id,
        id: null,
        desc_nivel: "",
        desc_grado: "",
        descripcion: "",
        id_capacidad: "",
        indexPrincipal: null,
        indexComp: null,
        indexCap: null,
      };

      this.resetValidationInd();
    },

    async addIndicador(
      itemsPrincipal,
      competencia,
      capacidades,
      indexPrincipal,
      id_capacidad,
      indexComp,
      indexCap
    ) {
      //console.log(`ITEMS COMPETENCIA: $itemsPrincipal}`)
      //console.log(itemsPrincipal)
      // console.log(`ITEMS CAPACIDADES: ${competencia}`)
      //console.log(competencia)
      // console.log(`ITEMS INDICADOR: ${capacidades}`)
      // console.log(capacidades)

      this.limpiarForm03();
      this.dialog_indicador = true;
      this.evento = "agregar";
      this.form03Title = "Agregar desempeño";

      this.form03.desc_nivel = itemsPrincipal.desc_nivel;
      this.form03.desc_grado = itemsPrincipal.desc_grado;
      this.form03.desc_area = itemsPrincipal.desc_area;
      this.form03.desc_competencia = competencia.descripcion;
      this.form03.desc_capacidades = capacidades.descripcion;

      // campos para recargar lista
      this.form03.id_capacidad = id_capacidad;
      this.form03.indexPrincipal = indexPrincipal;
      this.form03.indexComp = indexComp;
      this.form03.indexCap = indexCap;
    },

    async editIndicador(
      itemsPrincipal,
      competencia,
      capacidades,
      indicador,
      indexPrincipal,
      id_capacidad,
      indexComp,
      indexCap
    ) {
      // this.setEnviarMens({tipo:"W", mensaje: `HOLA Desempeño EDITAR`, tiempo:null})

      this.dialog_indicador = true;
      this.evento = "editar";
      this.form03Title = "Editar desempeño";

      //console.log(indicador)
      this.form03.desc_nivel = itemsPrincipal.desc_nivel;
      this.form03.desc_grado = itemsPrincipal.desc_grado;
      this.form03.desc_area = itemsPrincipal.desc_area;
      this.form03.desc_nivel = itemsPrincipal.desc_nivel;
      this.form03.desc_competencia = competencia.descripcion;
      this.form03.desc_capacidades = capacidades.descripcion;
      this.form03.id = indicador.id;
      this.form03.descripcion = indicador.descripcion;

      // campos para recargar lista
      this.form03.id_capacidad = id_capacidad;
      this.form03.indexPrincipal = indexPrincipal;
      this.form03.indexComp = indexComp;
      this.form03.indexCap = indexCap;
    },

    // Guardar registro para INDICADOR
    async saveIndicador(id) {
      //console.log(this.form03);
      if (this.$refs.formDatos03.validate()) {
        try {
          var res = "";
          if (this.evento == "agregar") {
            res = await axios.post("/manager/indicador/", {
              datos: this.form03,
            });
            this.dialog_confir_ind = true;
            // ACTUALIZAR INDICADORES O DESEMPEÑO

            this.setEnviarMens({
              tipo: `${res.data.messageT}`,
              mensaje: `${res.data.message}`,
              tiempo: null,
            });
          }

          if (this.evento == "editar") {
            res = await axios.put("/manager/indicador/" + id, this.form03);
            this.dialog_indicador = false;
            this.evento = null;
            this.eventCapacidad(
              1,
              this.form03.indexPrincipal,
              this.form03.id_capacidad,
              this.form03.indexComp,
              this.form03.indexCap
            );
            this.setEnviarMens({
              tipo: `${res.data.messageT}`,
              mensaje: `${res.data.message}`,
              tiempo: null,
            });
          }
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de Ingresar todo los campos requeridos`,
          tiempo: null,
        });
      }
    },

    // Evento de Confirmacion de Modal de Capacidades Agrtegar otra Capacidad
    async confirEventInd(event) {
      // Continuar Ingrsando true
      if (event) {
        this.form03.descripcion = "";
        this.resetValidationInd();
      } else {
        this.dialog_indicador = false;
        this.eventCapacidad(
          1,
          this.form03.indexPrincipal,
          this.form03.id_capacidad,
          this.form03.indexComp,
          this.form03.indexCap
        );
      }
    },

    async deleteIndicador(
      items,
      indexPrincipal,
      id_capacidad,
      indexComp,
      indexCap
    ) {
      //console.log(items)
      this.form03_delete = true;
      this.id_delete = items.id;
      this.desc_delete = items.descripcion;

      this.form03.id_capacidad = id_capacidad;
      this.form03.indexPrincipal = indexPrincipal;
      this.form03.indexComp = indexComp;
      this.form03.indexCap = indexCap;
    },

    //------------BORRAR Registro (Capacidades) -------------
    async deleteForm03() {
      try {
        let resp = await axios.delete("/manager/indicador/" + this.id_delete);
        this.form03_delete = false;

        // ACTUALIZAR INDICADORES O DESEMPEÑO
        this.eventCapacidad(
          1,
          this.form03.indexPrincipal,
          this.form03.id_capacidad,
          this.form03.indexComp,
          this.form03.indexCap
        );
        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: resp.data.message,
          tiempo: null,
        });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //  resetear Validcion de los campos capaciades
    resetValidationInd() {
      this.$refs.formDatos03.resetValidation();
    },
    //---- END    INIDICADOR  O DESEMPEÑO     -----//
  },
};
</script>

<style scoped>
.ico_competencia {
  color: #e53935 !important;
}

.ico_capacidad {
  color: #388e3c !important;
}

.ico_indicador {
  color: #01579b !important;
}

.head-competencias {
  background: #0277bd !important;
  color: white !important;
  font-size: 16px;
}

.head-capacidades {
  background: #59b9f2 !important;
  color: white !important;
}

.head-desempenios {
  background: #d0eaf9 !important;
  color: white !important;
}
</style>
